import { FormikErrors, setIn } from "formik";

export type FormErrors<Values> = { fieldErrors: FormikErrors<Values>; generalErrors: string[] };

const toCamelCasePath = (key: string) =>
  key
    .replace(/^\$\./, "")
    .split(".")
    .map((segment) => segment.charAt(0).toLowerCase() + segment.slice(1))
    .join(".");

const withoutTrailingIndex = (path: string) => path.replace(/\[\d+\]$/, "");

export const apiErrorsToFormErrors = <Values>(
  errors: Record<string, string[]>,
  fieldPaths: string[],
  toFieldPath: (path: string) => string = (path) => path
): FormErrors<Values> => {
  const knownPaths = new Set(fieldPaths);
  let fieldErrors: FormikErrors<Values> = {};
  const generalErrors: string[] = [];

  Object.entries(errors).forEach(([key, messages]) => {
    const path = toFieldPath(toCamelCasePath(key));
    const fieldPath = knownPaths.has(path) ? path : withoutTrailingIndex(path);
    if (knownPaths.has(fieldPath) && messages.length > 0) {
      fieldErrors = setIn(fieldErrors, fieldPath, messages[0]);
    } else {
      generalErrors.push(...messages);
    }
  });

  return { fieldErrors, generalErrors };
};

export const toReadableErrorMessage = (message: string): string => {
  try {
    const problem = JSON.parse(message);
    if (typeof problem?.detail === "string" && problem.detail) return problem.detail;
    if (typeof problem?.title === "string" && problem.title) return problem.title;
  } catch {
    // plain text, shown as it is
  }
  return message;
};
